export var getIsLeadFactory = function getIsLeadFactory(sellers) {
  return !!sellers.find(function (seller) {
    return seller.isLeadFactory;
  });
};